import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardType } from '../StreamCard';
import * as S from './CardPill.styles';

interface CardPillProps {
  type: CardType;
  isRead?: boolean;
}

export const CardPill = ({ type, isRead = false }: CardPillProps) => {
  const { t } = useTranslation(['stream']);

  const renderPill = () => {
    switch (type) {
      case CardType.CompanyCatalyst:
        return (
          <>
            <S.IconWrapper $isRead={isRead} $type={type}>
              <Icon
                iconName="PuzzleBorderless"
                size={12}
                fillColor={
                  isRead ? 'var(--icon-soft)' : 'var(--icon-decorative-lime)'
                }
                viewBox="0 0 12 12"
              />
            </S.IconWrapper>
            <S.TitleLabel $isRead={isRead} $type={type}>
              {t('stream:pills.companyCatalyst')}
            </S.TitleLabel>
          </>
        );
      case CardType.MarketCatalyst:
        return (
          <>
            <S.IconWrapper $isRead={isRead} $type={type}>
              <Icon
                iconName="PuzzleBorderless"
                size={12}
                fillColor={
                  isRead ? 'var(--icon-soft)' : 'var(--icon-decorative-cyan)'
                }
                viewBox="0 0 12 12"
              />
            </S.IconWrapper>
            <S.TitleLabel $isRead={isRead} $type={type}>
              {t('stream:pills.marketCatalyst')}
            </S.TitleLabel>
          </>
        );
      case CardType.MarketSummary:
        return (
          <>
            <S.IconWrapper $isRead={isRead} $type={type}>
              <Icon
                iconName="Newspaper"
                size={12}
                fillColor={
                  isRead ? 'var(--icon-soft)' : 'var(--icon-decorative-gold)'
                }
              />
            </S.IconWrapper>
            <S.TitleLabel $isRead={isRead} $type={type}>
              {t('stream:pills.marketSummary')}
            </S.TitleLabel>
          </>
        );
      case CardType.Scenario:
        return (
          <>
            <S.IconWrapper $isRead={isRead} $type={type}>
              <S.StyledScenarioIcon
                iconName="ExploreNav"
                size={12}
                $isRead={isRead}
              />
            </S.IconWrapper>
            <S.TitleLabel $isRead={isRead} $type={type}>
              {t('stream:pills.scenario')}
            </S.TitleLabel>
          </>
        );
      case CardType.EarningsPreview:
        return (
          <>
            <S.IconWrapper $isRead={isRead} $type={type}>
              <S.StyledEarningsPreviewIcon
                iconName="EarningsPreviewBorderless"
                size={12}
                viewBox="0 0 12 12"
                $isRead={isRead}
              />
            </S.IconWrapper>
            <S.TitleLabel $isRead={isRead} $type={type}>
              {t('stream:pills.preview')}
            </S.TitleLabel>
          </>
        );
      case CardType.EarningsRecap:
        return (
          <>
            <S.IconWrapper $isRead={isRead} $type={type}>
              <S.StyledEarningsRecapIcon
                iconName="EarningsRecapBorderless"
                size={12}
                viewBox="0 0 12 12"
                $isRead={isRead}
              />
            </S.IconWrapper>
            <S.TitleLabel $isRead={isRead} $type={type}>
              {t('stream:pills.recap')}
            </S.TitleLabel>
          </>
        );
      default:
        return null;
    }
  };

  return <S.StyledPillWrapper>{renderPill()}</S.StyledPillWrapper>;
};
